/**
 * Shared helpers for building the `/action` request, used by both the module
 * action and view-interaction transports.
 */

/** The `/action` endpoint URL for the given API base (trailing slash trimmed). */
export function actionUrl(apiBaseUrl: string): string {
  const trimmed = apiBaseUrl.replace(/\/+$/, "");
  return `${trimmed}/action`;
}

/**
 * The route the action fires from — the path the user is currently on. The SPA
 * keeps `window.location` in sync with the rendered view, and the server
 * flow-matches this to resolve the flow (the action endpoint's own URL does
 * not map to a flow).
 */
export function currentRoute(): string {
  return `${window.location.pathname}${window.location.search}`;
}
